import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { adsApi } from '../api/adsApi';
import type { OverviewRange } from '../api/campaignsApi';
import { adsKeys } from '../queryKeys';

export function useCampaigns(range?: OverviewRange) {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: adsKeys.campaigns(locationId, range ?? 'mtd'),
    queryFn: () => adsApi.getCampaigns(locationId, range),
    enabled: !!locationId,
  });
}
